import { CustomPageTitle, ListItem, ThematicsIconProvider } from '@components';
import { Container, Icon, Typography } from '@design-system';
import React from 'react';
import { BiSolidChat } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { useCauseriesTalkListPageVM } from './useCauseriesTalkListPageVM';

export const CauseriesTalkListPage: React.FC = () => {
    const { isLoading, talks, thematic } = useCauseriesTalkListPageVM();

    const navigate = useNavigate();

    return (
        <Container className="causeries-talk-list-page" height="fill">
            {thematic?.title && (
                <CustomPageTitle>
                    <Typography intrinsic="h3" iconColor="blue" icon={<BiSolidChat />} iconFilled iconSize={20}>
                        {thematic.title}
                    </Typography>
                </CustomPageTitle>
            )}

            <Typography intrinsic="h2" defaultSpacing className="mb-medium-spacing-forced">
                Les causeries
            </Typography>

            {isLoading ? (
                <>
                    <p>Chargement des causeries...</p>
                </>
            ) : (
                <>
                    {thematic && (
                        <div>
                            <ListItem
                                key={thematic.id}
                                title={thematic.title}
                                icon={
                                    <Icon icon={<ThematicsIconProvider icon={thematic.icon} />} size={24} color="green" variant="plain" />
                                }
                                onClick={() => {
                                    // Nothing to do
                                }}
                                type="dropdown"
                                dropdownItems={talks.map((talk) => ({
                                    id: talk.id,
                                    label: talk.title,
                                    onClick: () => navigate(`/sante-securite/causeries/list/${thematic.id}/files/${talk.id}`)
                                }))}
                            />
                        </div>
                    )}
                </>
            )}
        </Container>
    );
};
